import React from 'react';
import './Hero.css';
import banner from '../../assets/images/banner.jpeg';

function Hero() {
  return (
    <section id="home" className="hero" role="region" aria-label="Home section" style={{ backgroundImage: `url(${banner})` }}>
      <div className="hero-inner">
        <h1>We are building Next Generation Antibody Drug Conjugates For High Unmet Need Cancers
        </h1>
      </div>
    </section>
  );
}

export default Hero;

